import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-tinymcehtmleditor',
    templateUrl: './tinymcehtmleditor.component.html',
    styleUrls: ['./tinymcehtmleditor.component.scss']
})
export class TinymcehtmleditorComponent {

    @Input() html = '';

    @Input() htmlForm?: FormGroup;
    @Input() buttonBackGroundColor = '#E6A523';
    @Input() buttonTextColor = 'white';

    //TODO make button color config dynamic
    public editorConfig = {
        plugins: 'lists link image paste help wordcount',
        toolbar:
            'undo redo | myCustomButton | blocks | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help | image',
        setup: (editor: any) => {
            // Register the custom button
            editor.ui.registry.addButton('myCustomButton', {
                text: 'Insert Button',
                onAction: function () {
                    const buttonText = prompt('Enter custom button text:');
                    const hrefText = prompt('Enter link!');
                    const buttonBackgroundColor = this.buttonBackGroundColor;
                    const buttonTextColor = this.buttonTextColor;

                    if (buttonText !== null && buttonText !== '') {
                        editor.insertContent(`<a href=${hrefText} target="_blank" style="background-color: ${buttonBackgroundColor};color: ${buttonTextColor};font-size: 14px; padding: 8px 16px; border-radius: 8px; border: none; cursor: pointer; text-decoration: none; display: inline-block;">${buttonText}</a>`);
                    } else {
                        editor.insertContent('<a href=${hrefText} target="_blank" style="background-color: ${buttonBackgroundColor};color: ${buttonTextColor};font-size: 14px; padding: 8px 16px; border-radius: 8px; border: none; cursor: pointer; text-decoration: none; display: inline-block;">Click Me!</a>');
                    }
                }
            });
        }
    };

    constructor(private _fb: FormBuilder) {

    }

    get htmlElement() {
        return this.html;
    }

}
